export default "assets/images/icons/chevron-85449db4.svg";